<template>
  <div class="side_box">
    <div>
      <label for="lotnumber">Serie</label>
      <span v-if="this.item">{{this.item.rawMaterialID}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="ref">REF number</label>
      <span v-if="this.item">{{this.item.ref}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="subparts">Diameter</label>
      <span v-if="this.item">{{this.item.diameter}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="description">Description</label>
      <span v-if="this.item">{{this.item.description}}</span>
      <span v-else>...</span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
  },
  props: {
    item: Object
  },
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";

.side_box {
  max-height: 440px;
}
</style>
